const AreaType = {
  'Sq. Ft.' : 'Sq. Ft.',
  'Sq. Mt.' : 'Sq. Mt.'
};

export default Object.keys(AreaType).map( value => ({
    value,
    label: AreaType[value]
}));